import { createSelector } from "reselect";

export const auth = state => state.auth;

export const getCurrentUser = createSelector(auth, state => state.currentUser);

export const common = state => state.common;

export const isSidebarShowing = createSelector(
  common,
  state => state.isSidebarShowing,
);

export const getSettings = createSelector(common, state => state.settings);
export const getLocation = createSelector(common, state => state.location);
export const getHeight = createSelector(common, state => state.webHeight);
export const getShowError = createSelector(common, state => state.showError);
export const getMarginLayout = createSelector(common, state => state.marginLayout);
export const getSound = createSelector(common, state => state.sound);
